import { IUser } from '../../shared/iUser';
import IdentityProvider from '../../api/identity/identityProvider';
import identityProvider from '../../api/identity/identityProvider';

export const logoutAsync = identityProvider.logoutAsync;

export const getUserAsync = async (): Promise<IUser> => {
    let res = await IdentityProvider.getUserAsync();
    return {
        email: res.data.email,
        firstName: res.data.firstName,
        lastName: res.data.lastName,
        isAdmin: res.data.isAdmin,
        role: res.data.role,
    };
};
